import React from 'react';
import PropTypes from 'prop-types';
import styles from './Footer.module.css';
import Spinner from '../../Spinner/Spinner';
import InfoMessage from '../../InfoMessage/InfoMessage';

function Footer(props) {
    const { footerContent, showSpinner, errorMessage } = props;
    return (
        <div className={styles.ModalFooter}>
            <div className={styles.Content}>
                { footerContent }    
            </div>

            <div className={styles.ErrorContent}>
                { 
                    errorMessage ? (
                        <InfoMessage type="error" message={errorMessage} />
                    ) : null
                }    
            </div>

            <div className={styles.Spinner}>
                {
                    showSpinner ? (
                        <Spinner showMessage={false} style={{width: "24px", height: "24px"}} />
                    ) : null
                }
            </div>
        </div>
    )
}

Footer.propTypes = {
    showSpinner: PropTypes.bool,
    errorMessage: PropTypes.string
}

export default Footer;

